import queryString from 'query-string';
import { MINERVA_API_URL } from '@/config';
import { http } from '@/plugins/http';
import types from './mutation-types';

export function fetchClasses({ dispatch }) {
  return http.get(`${MINERVA_API_URL}/classes`)
    .then(res => (
      dispatch('setClassesInStore', res.data)
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while fetching classes:', err);
      return Promise.reject(err);
    });
}

export function syncClasses({ dispatch }) {
  return http.patch(`${MINERVA_API_URL}/classes`, {})
    .then(res => (
      dispatch('setClassesInStore', res.data)
    ))
    .then(() => {
      console.info('class list synced!');
    })
    .catch((err) => {
      // TODO: handle error
      console.error('err while syncing classes:', err);
      return Promise.reject(err);
    });
}

export function fetchClassStudents(_, classId) {
  return http.get(`${MINERVA_API_URL}/classes/${classId}/students`)
    .then(res => (
      res.data
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while fetching class students:', err);
      return Promise.reject(err);
    });
}

export function fetchClassStudent(_, { classId, studentId }) {
  return http.get(`${MINERVA_API_URL}/classes/${classId}/students/${studentId}`)
    .then(res => (
      res.data
    ))
    .catch((err) => {
      if (err.response && err.response.status === 404) {
        return null;
      }

      // TODO: handle error
      console.error('err while fetching class student:', err);
      return Promise.reject(err);
    });
}

export function syncClassStudents(_, classId) {
  return http.patch(`${MINERVA_API_URL}/classes/${classId}/students`, {})
    .then(res => (
      res.data
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while syncing class students:', err);
      return Promise.reject(err);
    });
}

export function manageClassStudents(_, { classId, students }) {
  return http.patch(`${MINERVA_API_URL}/classes/${classId}/student-info`, { students })
    .then(res => (
      res.data
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while managing class students:', err);
      return Promise.reject(err);
    });
}

export function fetchClassAssignments(_, classId) {
  return http.get(`${MINERVA_API_URL}/classes/${classId}/assignments`)
    .then(res => (
      res.data
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while fetching class assignments:', err);
      return Promise.reject(err);
    });
}

export function fetchClassTopics(_, classId) {
  return http.get(`${MINERVA_API_URL}/classes/${classId}/topics`)
    .then(res => (
      res.data
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while fetching class topics:', err);
      return Promise.reject(err);
    });
}

export function fetchChapterScores(_, params) {
  const queryParams = queryString.stringify(params);

  return http.get(`${MINERVA_API_URL}/scores/chapters?${queryParams}`)
    .then(res => (
      res.data
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while fetching chapter scores:', err);
      return Promise.reject(err);
    });
}

export function fetchCoreConceptScores(_, params) {
  const queryParams = queryString.stringify(params);

  return http.get(`${MINERVA_API_URL}/scores/core-concepts?${queryParams}`)
    .then(res => (
      res.data
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while fetching core concept scores:', err);
      return Promise.reject(err);
    });
}

export function fetchJoinedClasses({ dispatch }, params) {
  return http.get(`${MINERVA_API_URL}/users/me/joined_classes`, params)
    .then(res => (dispatch('setJoinedClasses', res.data)))
    .catch(err => Promise.reject(err));
}

export function setClassesInStore({ commit }, classList) {
  commit(types.SET_CLASSES, classList);

  return Promise.resolve(classList);
}

export function setSelectedClassId({ commit }, classId) {
  commit(types.SET_SELECTED, classId);

  return Promise.resolve();
}

export function setIsClassStudent({ commit }, isClassStudent) {
  commit(types.SET_IS_CLASS_STUDENT, isClassStudent);

  return Promise.resolve(isClassStudent);
}

export function setJoinedClasses({ commit }, joinedClasses) {
  commit(types.SET_JOINED_CLASSES, joinedClasses);

  return Promise.resolve(joinedClasses);
}
